<div
  id="accessibility"
  class="container pt-5">
  <div>
    <div class="d-flex float-start">
      <div class="wf-main-logo">
        <wfs-wf-logo></wfs-wf-logo>
      </div>
      <div class="logo-text">Webbformulär</div>
    </div>
    <div
      class="region-logo-container"
      style="float: right; padding-top: 15px">
      <img
        src="/content/region-stockholm-400.png"
        srcset="/content/region-stockholm-300.png 300w, /content/region-stockholm-400.png 400w"
        sizes="(max-width: 480px) 300px, 400px"
        alt="loggor för Region Stockholm och Region Gotland" />
    </div>
  </div>
  <div class="content-container">
    <article>
      <h1>Tillgänglighet för Webbformulär</h1>
      <p>
        Webbformulär är ett verktyg som ägs av Region Stockholm. Det är önskvärt att det ska kunna användas av de flesta
        av regionens invånare. Detta dokument beskriver hur Webbformulär uppfyller lagen om tillgänglighet till digital
        offentlig service, eventuella kända tillgänglighetsproblem och hur du kan rapportera brister till oss så att vi
        kan åtgärda dem.
      </p>
      <h2>Vad kan du göra om du inte kan använda delar av Webbformulär</h2>
      <p>
        Om du inte kan genomföra formuläret kan du alltid kontakta den mottagning eller avdelning som har bokat
        Webbformuläret åt dig. De kan hjälpa dig att fylla i formuläret eller komma åt det på annat sätt.
      </p>
      <h2>Rapportera brister i Webbformulärs tillgänglighet</h2>
      <p>
        Vi strävar hela tiden efter att förbättra Webbformulärs tillgänglighet. Om du upptäcker problem som inte är
        beskrivna på den här sidan, eller om du anser att vi inte uppfyller lagens krav,
        <a
          class="wf-dark-blue link-focus-shadow link-no-decoration"
          href="mailto:rvlp@regionstockholm.se">
          meddela oss
          <i class="fas fa-external-link-alt"></i>
        </a>
        så att vi får veta att problemet finns.
      </p>
      <p>
        Du kan nå oss på:
        <a
          class="wf-dark-blue link-focus-shadow link-no-decoration"
          href="mailto:rvlp@regionstockholm.se">
          rvlp@regionstockholm.se
          <i class="fas fa-external-link-alt"></i>
        </a>
      </p>
      <h2>Tillsyn</h2>
      <p>
        Myndigheten för digital förvaltning, Digg, har ansvaret för tillsyn över lagen om tillgänglighet till digital
        offentlig service. Du kan
        <a
          class="wf-dark-blue link-focus-shadow link-no-decoration"
          href="https://www.digg.se/tdosanmalan"
          target="_blank">
          anmäla till Digg
          <i class="fas fa-external-link-alt"></i>
        </a>
        om du tycker att vår digitala service har brister i tillgänglighet. Du kan också
        <a
          class="wf-dark-blue link-focus-shadow link-no-decoration"
          href="https://www.digg.se/tdosanmalan"
          target="_blank">
          anmäla till Digg
          <i class="fas fa-external-link-alt"></i>
        </a>
        om du tycker att vår bedömning av vad som är oskäligt betungande ska granskas, om du tycker att vår
        tillgänglighetsredogörelse har brister eller om du tycker att vi inte har hanterat din begäran om
        tillgängliggörande korrekt.
      </p>
      <p>
        Myndigheten kan nås på följande länk:
        <a
          class="wf-dark-blue link-focus-shadow link-no-decoration"
          href="https://www.digg.se/tdosanmalan"
          target="_blank">
          https://www.digg.se/tdosanmalan
          <i class="fas fa-external-link-alt"></i>
        </a>
      </p>

      <h2 class="word-break">Hur arbetar Region Stockholm med tillgänglighetsanpassningen</h2>
      <p>Region Stockholm arbetar löpande med tillgängligheten i Webbformulär:</p>
      <div>
        <ul>
          <li>Gemensamma komponenter har anpassats</li>
          <li>
            Nya formulär ska vara tillgänglighetsanpassade när de släpps. Detta säkerställs genom att följa:
            <ul>
              <li>Enligt implementerade arbetssätt och rutiner.</li>
              <li>Checklistor för nyutveckling av formulär.</li>
            </ul>
          </li>
        </ul>
      </div>

      <h2>Granskningsmetod och godkännande av formulär</h2>
      <p>
        Varje formulär har granskats och testats enligt checklistor från WCAG 2.1 (Webbtillgänglighetsdirektivet).
        Beteenden och komponenter som inte uppfyllde tillgänglighetsdirektiven har anpassats.
      </p>
      <p>
        Formulären har testats i webbläsaren Chrome tillsammans med NVDA (NonVisual Desktop Access) som
        uppläsningsverktyg.
      </p>

      <h2>Innehåll som inte är tillgänglighetsanpassat</h2>
      <p>
        Vissa formulär kan inte uppfylla kraven gällande bland annat formuleringar och utseende då
        upphovsrättsinnehavaren inte gett sitt medgivande.
      </p>

      <h2>Teknisk information om Webbformulärs tillgänglighet</h2>
      <p>
        För närvarande uppfyller Webbformulär delvis lagkravet för digital tillgänglighet inom offentlig service. Vi
        redovisar bristerna på ett övergripande plan.
      </p>
      <p>
        Vi är medvetna om att vi inte uppfyller alla kriterier enligt WCAG 2.1 i Webbformulär, inom följande områden:
      </p>
      <ul>
        <li>
          Ge användarna möjlighet att justera tidsbegränsningar (direktiv 131)
          <ul>
            <li>
              Då den information som invånare lämnar i Webbformulär är av känslig karaktär har Region Stockholm beslutat
              att inte erbjuda användare möjlighet att justera tidsbegränsningar.
            </li>
            <li>
              Detta innebär att om en invånare, inloggad i Webbformulär, är inaktiv i mer än 10 minuter, så loggas hen
              automatiskt ut. Om invånaren har börjat svara på formuläret, så sparas dessa svar i ett utkast (förutom
              för anonyma formulär). Invånaren kan när som helst logga in igen och öppna upp utkastet och fortsätta
              besvara formuläret.
            </li>
          </ul>
        </li>
      </ul>
      <h2>Uppdatering av redogörelsen</h2>
      <p>Denna redogörelse uppdaterades 2025-02-18.</p>
    </article>
  </div>
</div>
